import { sensorMap } from '../config/locations';

const getSensorLabel = (sensorId) => {
  const info = sensorMap[sensorId];
  return info ? `${info.position}` : `Sensor ${sensorId}`;
};

export const downloadCSV = (data, locationName = '', startDate, endDate, sensorIds = [], viewMode = 'current') => {
  const formatDate = (date) => {
    if (typeof date === 'string') date = new Date(date);
    return date.toISOString().split('T')[0];
  };
  
  const downloadDate = new Date().toISOString().split('T')[0];
  const dataType = viewMode === 'current' ? 'realtime' : 'historical';
  
  const filename = locationName
    ? `${locationName.replace(/[^a-z0-9]/gi, '_').toLowerCase()}_${dataType}_${formatDate(startDate)}_to_${formatDate(endDate)}_downloaded_${downloadDate}.csv`
    : `air_quality_${dataType}_${formatDate(startDate)}_to_${formatDate(endDate)}_downloaded_${downloadDate}.csv`;


  let headers, rows;
  
  if (viewMode === 'current') {
    headers = [
      'Timestamp',
      ...sensorIds.map(id => `${getSensorLabel(id)} (µg/m³)`),
      'Adjusted Average (µg/m³)',
      'Raw Average (µg/m³)'
    ];

    rows = data.map(row => {
      const sensorValues = sensorIds.map(id => row[id] ? row[id].toFixed(1) : '');
      return [
        new Date(row.rawTimestamp).toISOString(),
        ...sensorValues,
        row.average ? row.average.toFixed(1) : '',
        row.rawAverage ? row.rawAverage.toFixed(1) : ''
      ];
    });
  } else {
    headers = [
      'Date',
      ...Object.keys(data[0] || {})
        .filter(key => key.startsWith('sensor') || key === 'average')
        .map(key => key === 'average' ? 'Average (µg/m³)' : `${getSensorLabel(key.replace('sensor', ''))} (µg/m³)`)
    ];

    rows = data.map(row => [
      row.date,
      ...Object.keys(row)
        .filter(key => key.startsWith('sensor') || key === 'average')
        .map(key => row[key]?.toFixed(1) || '')
    ]);
  }

  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(','))
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
